import { Component, JSX } from "react";
import "../../../../App.scss";
import { appContext } from "../../../../AppContext";
import { IUserRights } from "../../../../Providers.Api/Models.UserApi";
import { IRouterProps, Typography, withRouting } from "@iconics/components";

class Root extends Component<IRouterProps>
{
    private labels = appContext().labels;
    private local = appContext().localStorageProvider;

    constructor(props: IRouterProps)
    {
        super(props);
        this.authCheck();
    }

    public authCheck(): void
    {
        const token = appContext().authentication.getToken();
        if (!token)
        {
            this.pushHistory("/login");
        }
    }

    public componentDidMount(): void
    {
        const userDetails = this.local.getUserDetails()
        if (userDetails?.userRights)
        {
            this.redirect(userDetails.userRights);
            return;
        }

        this.pushHistory("/login");
    }

    private redirect(rights: IUserRights): void
    {
        if (rights.ADMINPORTAL)
        {
            this.pushHistory(`/security-identity-providers`);
        }
        else
        {
            this.pushHistory("/norights");
        }
    }

    private pushHistory(url: string): void
    {
        this.props.navigate(url, { replace: true });
    }

    public render(): JSX.Element
    {
        return (
            <div>
                <div className="redirectContainer">
                    <div className="title">
                        <Typography role="title" size="medium">{this.labels.Platform_RedirectionStatus_Title}</Typography>
                    </div>
                    <div className="subtitle">
                        <Typography role="body" size="medium">{this.labels.Platform_RedirectionStatus_SubTitle} <span id="countdown"></span></Typography>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouting(Root);
